// The wall as it stands on a physical table (design 10 §4; EMA Riichi Rules 2025 §2.5–2.8): four sides of 17
// stacks, two tiles high, broken where East's dice say, and every index of the record's wall permutation
// (design 2 §3.4) mapped onto a stack.
//
// Going clockwise round the table from the break, the record's indices 0–121 (the deal, East's jump
// included, then the live wall) fall stack after stack, the top tile first; the dead wall is the seven
// stacks counter-clockwise from the break: the four replacement tiles nearest the break, then the indicator
// stacks, the dora indicator on top of the third (ura dora beneath, kan dora further along).

import { SEATS } from "./view";

export const STACKS = 17; // per side
const RING = STACKS * SEATS;
const DEAD_FROM = 122; // the record's dead wall: replacements 122–125, indicators 126–135

/** Two dice for the hand, the same for every seat and in replays. Riichi records have no dice (the shuffle
 *  alone decides the wall), so the roll shown is cosmetic, derived from public data. */
export function dice(gameId: string, hand: number): [number, number] {
  let h = 2166136261;
  for (const c of `${gameId}:${hand}`) h = Math.imul(h ^ c.charCodeAt(0), 16777619) >>> 0;
  return [1 + (h % 6), 1 + ((h >>> 8) % 6)];
}

export interface WallSpot {
  seat: number; // whose side of the table the stack stands on
  k: number; // the stack, counted from that seat's right end (0) to its left (16)
  top: boolean; // the upper tile of the stack
}

/** Where wall index `index` stands, for a hand dealt by `dealer` with dice total `total`. East counts the
 *  total counter-clockwise from themselves to choose the wall, and as many stacks from its right end to
 *  break it (§2.5). Clockwise along a side runs from its owner's right end to its left. */
export function wallSpot(index: number, dealer: number, total: number): WallSpot {
  const owner = (dealer + total - 1) % SEATS;
  let ring: number;
  let top: boolean;
  if (index < DEAD_FROM) {
    ring = total + Math.floor(index / 2);
    top = index % 2 === 0;
  } else {
    const j = index - DEAD_FROM;
    ring = total - 1 - Math.floor(j / 2);
    top = j % 2 === 0;
  }
  ring = ((ring % RING) + RING) % RING;
  const side = Math.floor(ring / STACKS); // sides clockwise from the owner's: the owner, then the seat on its left...
  return { seat: (owner - side + SEATS * 2) % SEATS, k: ring % STACKS, top };
}
